import { render } from "./StatsGeneric.vue?vue&type=template&id=5b3fffff"
import script from "./StatsGeneric.vue?vue&type=script&lang=js"
export * from "./StatsGeneric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__